import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMusicNote16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMusicNote16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v9l-.006.08q.006.084.006.17a2.25 2.25 0 1 1-1-1.871V5.47l-.037.001H7V11.5l-.006.08q.006.084.006.17a2.25 2.25 0 1 1-1-1.871zm1 1.971h5.963q.019 0 .037.002V3H7zM6 11.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m7 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMusicNote16);
